import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCompass = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C6.75329 21.5 2.5 17.2467 2.5 12C2.5 6.75329 6.75329 2.5 12 2.5C17.2467 2.5 21.5 6.75329 21.5 12Z",
			fill: "#DBE4E8",
			stroke: "#293235",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 8L13.4151 13.4151L8 16L10.5849 10.5849L16 8Z",
			stroke: "#293235",
			strokeWidth: .875,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.5849 10.5849L13.4151 13.4151",
			stroke: "#293235",
			strokeWidth: .875
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3 11.5H4.5C4.77614 11.5 5 11.7239 5 12V12C5 12.2761 4.77614 12.5 4.5 12.5H3V11.5Z",
			fill: "#293235"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21 12.5H19.5C19.2239 12.5 19 12.2761 19 12V12C19 11.7239 19.2239 11.5 19.5 11.5H21V12.5Z",
			fill: "#293235"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.5 3H12.5V4.5C12.5 4.77614 12.2761 5 12 5V5C11.7239 5 11.5 4.77614 11.5 4.5V3Z",
			fill: "#293235"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.5 21H12.5V19.5C12.5 19.2239 12.2761 19 12 19V19C11.7239 19 11.5 19.2239 11.5 19.5V21Z",
			fill: "#293235"
		})
	]
});
const ForwardRef = forwardRef(SvgCompass);
export { ForwardRef as ReactComponent };
